<div class="p-4 bg-gray-200 rounded space-y-1 mb-2 mt-1">
  <mat-form-field class="w-full h-12 min-h-12">
    <mat-select [formControl]="selectCtrl" #singleSelect [disabled]="isDisabled()">
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Diagnóstico" [formControl]="filterCtrl">
          <div ngxMatSelectNoEntriesFound class="flex justify-between">
            <span> Nenhum registro corresponde à pesquisa. </span>
            <mat-progress-spinner *ngIf="loading$ | async" mode="indeterminate" [diameter]="32" color="primary"></mat-progress-spinner>
          </div>
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let item of datasource$ | async" [value]="item">
        {{ item.subCategoryId }} - {{ item.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="flex flex-col space-y-1">
    <div *ngFor="let icd of selected" class="flex flex-row p-2 rounded w-full justify-between items-center bg-gray-100">
      <span>{{ icd.subCategoryId }} - {{ icd.title }}</span>
      <button mat-icon-button (click)="remove(icd)">
        <mat-icon class="mat-18">clear</mat-icon>
      </button>
    </div>
  </div>
</div>
